
import {
    Box,
    Typography,
    Button,
    TextField,
    Grid,
} from '@mui/material';
import { useEffect, useState } from 'react';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { SketchPicker } from 'react-color';
import { useDispatch, useSelector } from 'react-redux';
import { Formik, Form, Field } from 'formik';
import actions from '../../ReduxStore/actions';
import { adminUrl } from '../../constants';
import { toast, ToastContainer } from 'react-toastify';
import { setHeaderName, setSubHeaderName } from '../../ReduxStore/Slices/headerSlice';

const BrandingSettings = () => {
    const dispatch = useDispatch();

    const { getSiteSettings } = useSelector(
        (state) => state?.getSiteSettings
    );
    const [logoPreview, setLogoPreview] = useState(null);
    const [faviconPreview, setFaviconPreview] = useState(null);
    const [bannerPreview, setBannerPreview] = useState(null);
    const [initialValues, setInitialValues] = useState({
        logo: '',
        favicon: '',
        banner: '',
        themeColor: '#1976d2',
        appName: ''
    });
    useEffect(() => {
        dispatch(setHeaderName("Settings"));
        dispatch(setSubHeaderName("Theme Settings"));
    }, [dispatch]);


    console.log(logoPreview, "logoPreviewlogoPreview")
    // useEffect(() => {
    //     dispatch(actions.GETSITESETTINGS()); // assuming you have this action to load settings
    // }, [dispatch]);

    useEffect(() => {
        if (getSiteSettings) {
            const logoUrl = getSiteSettings?.data?.logo || '';
            const faviconUrl = getSiteSettings?.data?.favicon || '';
            const bannerUrl = getSiteSettings?.data?.banner_image || '';
            console.log(logoUrl, "logoUrl")

            setInitialValues({
                logo: logoUrl,
                favicon: faviconUrl,
                banner: bannerUrl,
                themeColor: getSiteSettings?.data?.primary_color || '#1976d2',
                appName: getSiteSettings?.data?.company_name || ''
            });

            if (logoUrl) setLogoPreview(`${adminUrl}${logoUrl}`);
            if (faviconUrl) setFaviconPreview(`${adminUrl}${faviconUrl}`);
            if (bannerUrl) setBannerPreview(`${adminUrl}${bannerUrl}`);
        }
    }, [getSiteSettings]);

    const handleFileChange = async (event, setFieldValue, fieldName, setPreview) => {
        const file = event.currentTarget.files[0];
        if (file) {
            const formData = new FormData();
            formData.append("uploadImage", file);

            const data1 = {
                data: formData,
                method: "post",
                apiName: "uploadImage",
            };

            try {
                const response = await dispatch(actions.UPLOADIMAGE(data1));
                const fileUrl = response?.payload?.data?.imageUrl;
                setFieldValue(fieldName, fileUrl);
                setPreview(`${adminUrl}${fileUrl}`);
            } catch (error) {
                console.error("Upload failed:", error);
            }
        }
    };

    const handleSubmit = async (values, { resetForm }) => {
        const data1 = {
            data: {
                primary_color: values?.themeColor,
                logo: values?.logo,
                favicon: values?.favicon,
                // banner_image: values?.banner,
                // company_name: values?.appName
            },
            method: "post",
            apiName: `saveSiteSettings`
        };
        const response = await dispatch(actions.SAVESSITESETTINGS(data1));
        if (response?.payload?.message === "Site settings saved successfully.") {
            toast.success('Site settings saved successfully.');
            setTimeout(() => {
                resetForm();
            }, 1500);
        } else {
            toast.error(response?.payload?.message);
        }
    };

    const handleFileChangeFavicon = (e, setFieldValue, fieldName, setPreview) => {
        const file = e.target.files[0];

        if (!file) return;

        // Check extension
        const isIco = file.name.toLowerCase().endsWith('.ico');
        if (!isIco) {
            toast.error("Only .ico files are allowed.");
            return;
        }

        const reader = new FileReader();
        reader.onload = function (event) {
            const img = new Image();
            img.onload = function () {
                const validSizes = [16, 32, 48, 64]; // Add more if needed
                if (!validSizes.includes(img.width) || img.width !== img.height) {
                    toast.error("Favicon must be square and 16x16 or 32x32 pixels.");
                    return;
                }

                // If valid
                setPreview(event.target.result);
                setFieldValue(fieldName, file);
            };
            img.onerror = function () {
                toast.error("Invalid image file.");
            };
            img.src = event.target.result;
        };
        reader.readAsDataURL(file);
    };

    return (
        <Box sx={{ p: 2 }}>
            <Formik
                // initialValues={{
                //     logo: '',
                //     favicon: '',
                //     banner: '',
                //     themeColor: '#1976d2',
                //     appName: ''
                // }}
                // onSubmit={handleSubmit}

                enableReinitialize
                initialValues={initialValues}
                onSubmit={handleSubmit}
            >
                {({ values, setFieldValue }) => (
                    <Form>
                        <Grid container spacing={4}
                        // sx={{ border: "1px solid lightgray" }}
                        >

                            {/* Logo Upload */}
                            <Grid item size={{ xs: 12, md: 12 }} sx={{
                                //  boxShadow: 4,
                                background: "white",
                                p: 4
                            }}>
                                <Grid container spacing={2}>
                                    <Grid item size={{ xs: 12, md: 6 }}>

                                        <Typography variant="h6"
                                            // align="center"
                                            mb={2}>Upload Logo <span style={{ fontSize: "14px", color: "gray" }}> (.png only) </span></Typography>
                                        <Box
                                        //  display="flex" flexDirection="column" alignItems="center"
                                        >
                                            <Box>
                                                <Button
                                                    component="label"
                                                    variant="outlined"
                                                    sx={{
                                                        py: 4,
                                                        px: 8,
                                                        mt: 2,
                                                        borderRadius: 2,
                                                        borderStyle: 'dashed',
                                                        borderColor: 'gray',
                                                        bgcolor: '#fff',
                                                        cursor: 'pointer',
                                                        textTransform: 'none',
                                                        '&:hover': {
                                                            borderColor: 'primary.main',
                                                            bgcolor: '#f0f0f0',
                                                        },
                                                    }}
                                                >
                                                    <CloudUploadIcon sx={{ fontSize: 60, color: "var(--main-color)" }} />
                                                    <input
                                                        type="file"
                                                        accept=".png"
                                                        hidden
                                                        onChange={(e) =>
                                                            handleFileChange(e, setFieldValue, 'logo', setLogoPreview)
                                                        }
                                                    />
                                                </Button>
                                            </Box>
                                        </Box>

                                    </Grid>
                                    <Grid item size={{ xs: 12, md: 6 }}>


                                        {logoPreview && (
                                            <Box mt={2}>
                                                <Typography variant="body2" mb={2} sx={{ color: "black" }}>Preview:</Typography>
                                                <img src={logoPreview} alt="Logo Preview" width="250" height="70px" />
                                            </Box>
                                        )}

                                    </Grid>

                                </Grid>
                            </Grid>

                            {/* Favicon Upload */}
                            <Grid item size={{ xs: 12, md: 12 }} sx={{
                                // boxShadow: 4,
                                backgroundColor: "white",
                                p: 4
                            }}>
                                <Grid container spacing={2}>
                                    <Grid item size={{ xs: 12, md: 6 }}>
                                        <Typography variant="h6"
                                            //  align="center" 
                                            mb={2}>Upload Favicon <span style={{ fontSize: "14px", color: "gray" }}>(.ico only)</span></Typography>
                                        <Box
                                        // display="flex" flexDirection="column" alignItems="center"
                                        >
                                            <Button
                                                component="label"
                                                variant="outlined"
                                                sx={{
                                                    py: 4,
                                                    px: 8,
                                                    mt: 2,
                                                    borderRadius: 2,
                                                    borderStyle: 'dashed',
                                                    borderColor: 'gray',
                                                    bgcolor: '#fff',
                                                    cursor: 'pointer',
                                                    textTransform: 'none',
                                                    '&:hover': {
                                                        borderColor: 'color:"var(--main-color)"',
                                                        bgcolor: '#f0f0f0',
                                                    },
                                                }}
                                            >
                                                <CloudUploadIcon sx={{ fontSize: 60, color: "var(--main-color)" }} />
                                                <input
                                                    type="file"
                                                    accept=".ico"
                                                    hidden
                                                    onChange={(e) =>
                                                        handleFileChangeFavicon(e, setFieldValue, 'favicon', setFaviconPreview)
                                                    }
                                                />
                                            </Button>
                                        </Box>
                                    </Grid>
                                    <Grid item size={{ xs: 12, md: 6 }}>


                                        {faviconPreview && (
                                            <Box mt={2}>
                                                <Typography variant="body2" mb={2} sx={{ color: 'black' }}>Preview:</Typography>
                                                <img src={faviconPreview} alt="Favicon Preview" width="60" height="60" />
                                            </Box>
                                        )}
                                    </Grid>
                                </Grid>

                            </Grid>

                            {/* Banner Upload */}
                            {/* <Grid item size={{ xs: 12, md: 6 }} sx={{ boxShadow: 4, p: 4 }}>
                                <Typography variant="h6" align="center" mb={2}>Upload Banner <span style={{ fontSize: "14px", color: "gray" }}> (jpeg, jpg, png) </span></Typography>
                                <Box display="flex" flexDirection="column" alignItems="center">
                                    <Button
                                        component="label"
                                        variant="outlined"
                                        sx={{
                                            py: 4,
                                            px: 6,
                                            borderRadius: 2,
                                            borderStyle: 'dashed',
                                            borderColor: 'gray',
                                            bgcolor: '#fff',
                                            cursor: 'pointer',
                                            textTransform: 'none',
                                            '&:hover': {
                                                borderColor: 'primary.main',
                                                bgcolor: '#f0f0f0',
                                            },
                                        }}
                                    >
                                        <CloudUploadIcon sx={{ fontSize: 80, color: "var(--main-color)" }} />
                                        <input
                                            type="file"
                                            accept=".jpeg,.jpg,.png"
                                            hidden
                                            onChange={(e) =>
                                                handleFileChange(e, setFieldValue, 'banner', setBannerPreview)
                                            }
                                        />
                                    </Button>
                                    {bannerPreview && (
                                        <Box mt={2}>
                                            <Typography variant="body2" mb={2}>Preview:</Typography>
                                            <img src={bannerPreview} alt="Banner Preview" width="100%" />
                                        </Box>
                                    )}
                                </Box>
                            </Grid> */}

                            {/* App Name and Theme Color */}
                            <Grid item size={{ xs: 12, md: 12 }} sx={{ 
                                // boxShadow: 4, 
                                backgroundColor:"white",
                                p: 4 }}>
                                {/* <Typography variant="h6" mt={2}>Application Name</Typography>
                                <Field
                                    as={TextField}
                                    name="appName"
                                    fullWidth
                                    variant="outlined"
                                    placeholder="Enter app name"
                                    sx={{ mt: 2 }}
                                /> */}
                                <Typography variant="h6">Select Theme Color</Typography>
                                <Box mt={2}>
                                    <SketchPicker
                                        color={values.themeColor}
                                        onChangeComplete={(color) => setFieldValue('themeColor', color.hex)}
                                    />
                                </Box>
                            </Grid>

                            {/* Save Button */}
                            <Grid item size={{ xs: 12 }} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <Button
                                    variant="contained"
                                    // color="primary"
                                    sx={{ mt: 4, background: "var(--main-color)", color: "white", mb: 2, textTransform: "none" }}
                                    type="submit"
                                >
                                    Save Settings
                                </Button>
                            </Grid>
                        </Grid>
                    </Form>
                )}
            </Formik>
            <ToastContainer
                position="top-right"
                autoClose={1500}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
            />
        </Box >
    );
};

export default BrandingSettings;
